export const data = {
  skills: [
    {
      name: "Ruby",
      file: "ruby.png",
      type_id: 1,
    },
    {
      name: "Rails",
      file: "rails.png",
      type_id: 2,
    },
    {
      name: "PostgreSQL",
      file: "postgresql.png",
      type_id: 3,
    },
    {
      name: "git",
      file: "git.png",
      type_id: 4,
    },
    {
      name: "github",
      file: "github.png",
      type_id: 4,
    },
    {
      name: "JavaScript",
      file: "javascript.png",
      type_id: 1,
    },
    {
      name: "Docker",
      file: "docker.jpeg",
      type_id: 4,
    },
    {
      name: "n8n",
      file: "n8n.png",
      type_id: 5,
    },
    // {
    //   name: "Linux",
    //   file: "linux.png",
    //   type_id: 5,
    // },
    // {
    //   name: "MongoDB",
    //   file: "mongodb.png",
    //   type_id: 3,
    // },
    // {
    //   name: "Heroku",
    //   file: "heroku.png",
    //   type_id: 6,
    // },
  ],
  types: [
    {
      id: 1,
      name: "programming language",
    },
    {
      id: 2,
      name: "framework",
    },
    {
      id: 3,
      name: "database",
    },
    {
      id: 4,
      name: "vcs",
    },
    {
      id: 5,
      name: "os",
    },
    {
      id: 6,
      name: "cloud",
    },
  ],
};
